import { useRouter } from 'next/router';
import { useSnapshot } from 'valtio/react';

import { Button } from '@paid-ui/components/button';

import { useInvitationSearchParams } from '../../hooks/search-params';
import { signUpManager } from '../../models';
import { SignUpStep } from '../../models/enums';

interface Props {
  disabled?: boolean;
}

export const StepReviewContract: React.FC<Props> = ({ disabled }) => {
  const router = useRouter();
  const { currentStep } = useSnapshot(signUpManager);
  const { contractType, contractId, partyId } = useInvitationSearchParams();

  if (currentStep !== SignUpStep.REVIEW_CONTRACT) {
    return null;
  }

  const handleClick = () => {
    if (!contractType || !contractId || !partyId) return;
    const urlSearchParams = new URLSearchParams(globalThis.location.search);
    const dialog = urlSearchParams.get('dialog') || 'complete-contract';
    urlSearchParams.delete('step');
    urlSearchParams.set('dialog', dialog);
    urlSearchParams.set('contractType', contractType);
    urlSearchParams.set('contractId', contractId);
    if (partyId) {
      urlSearchParams.set('partyId', partyId);
    }
    urlSearchParams.sort();
    router.push({
      pathname: '/',
      search: urlSearchParams.toString(),
    });
  };

  return (
    <div className="space-y-9">
      <Button size="xl" variant="solid" disabled={disabled} onClick={handleClick}>
        Review contract
      </Button>
    </div>
  );
};
